module.exports = __webpack_public_path__ + "static/MEDICI_default-badf706161e216df35e18e8bc0d534b2.jpg";